import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Login } from '../components/account/Login';
import { AEDashboard } from '../components/views/AEDashboard';
import { ELPDashboard } from '../components/views/ELPDashboard';
import { ApplicationState } from './../store';
import * as AuthorizationStore from './../store/Authorization';


interface Props {
    authorization: AuthorizationStore.IState;
    authorizationActions: typeof AuthorizationStore.actionCreators;
}

const HomeToConnect = (props: Props) => (
    <div>
        <h1>Alberta International Medical Graduate Program Portal</h1>
        <p>Welcome to the Alberta International Medical Graduate Program portal.</p>

        {!props.authorization.isSignedIn &&
            <>
            <div className="disclaimer-box">
                <p className="disclaimer">The Alberta International Medical Graduate Program (AIMG Program) application portal collects applicant information in several parts. The AIMG Program Notice of Collection applies to all parts of the application portal.</p>

                <p className="disclaimer">The University of Calgary (UCalgary) respects your privacy and is committed to ensuring the privacy of all students, staff, and community members. UCalgary operates the Alberta International Medical Graduate program (AIMG Program) and this notice applies to all personal information collected through the AIMG applicant portal. Your personal information is being collected under the authority of section 4(c) of the Alberta Protection of Privacy Act, SA 2024, c P-28.5 (POPA). It will be managed in accordance with UCalgary's Privacy Policy and as outlined below.</p>

                <p className="disclaimer">Your personal information is being collected for the purpose of evaluating your application for admission to the AIMG Program. It will form part of your AIMG Program record and will be used for applicant identity verification, residency eligibility assessment, program registration and coordination, communication with applicants, program evaluation, quality assurance, and improvement, and coordination of externship activities. Specific data elements, including your name, application and assessment dates, and residency program, may be disclosed to provincial and federal government bodies, the University of Calgary and University of Alberta postgraduate programs, and CaRMS for the purposes of your participation in the AIMG Program and to meet reporting requirements.</p>

                <p className="disclaimer">We recognize the sensitive nature of your personal information and are committed to the protection of your privacy. UCalgary will treat your personal information as confidential at all times and will make reasonable security arrangements against such risks as unauthorized access to, collection, use, disclosure, or destruction in accordance with POPA. Access to your personal information will be restricted to a limited number of designated individuals in the AIMG Program and your personal information will only be disclosed in de-identified form, or as otherwise permitted under POPA. Your personal information may be input into automated systems to generate content, make decisions, recommendations, or predictions.</p>

                <p className="disclaimer">If you have any questions regarding this notice or the collection, use, or disclosure of your personal information, please contact the AIMG Program office by 403-210-7790 or aimg@ucalgary.ca or the UCalgary Access and Privacy Office at accessandprivacy@ucalgary.ca.</p>

            </div>

            {/*<p>The Application Portal is closed. It will open for the 2025 Cycle in May 2024. Please see the <a href="https://www.aimg.ca/important-dates-deadlines/">Important Dates and Deadlines</a> for details. Email your questions to <a href="mailto:aimg@ucalgary.ca">aimg@ucalgary.ca</a></p>*/}
                {/*<p>
                    Please note that user names and passwords from 2022 and earlier match cycles are no longer registered.
                    If you applied between 2018 and 2022, please use the <a href="/register">Re-Register</a> option and we will retreive your profile from that application.

                </p>
                <p>
                    If you are a first-time applicant or applied prior to 2018, please use the <a href="/register">Register</a> option before you can sign in and begin an online application.
                </p>
                */}
            </>
        }
        <Login />

        <AEDashboard />

        <ELPDashboard />
    </div>
);

const Home = connect(
    (state: ApplicationState) => ({
        authorization: state.authorization
    }), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        authorizationActions: bindActionCreators(AuthorizationStore.actionCreators, dispatch)
    })

)(HomeToConnect as any)

export { Home };
